// Design tokens — mirror prototype <style> block + sibling app Theme.jsx
// Prototype source-of-truth: working files/Inboxlogy_SupportOptimization_Prototype.html (lines 11-56)
// Sibling app: /Users/twkl/Project Claude/Inboxlogy/UI:UX Redesign/src/theme/Theme.jsx

export const tokens = {
    color: {
        // Primary + opacity ladder (7 stops · matches --primary-* in prototype)
        primary: '#4A66F1',
        primary90: 'rgba(74, 102, 241, 0.9)',
        primary50: 'rgba(74, 102, 241, 0.5)',
        primary30: 'rgba(74, 102, 241, 0.3)',
        primary20: 'rgba(74, 102, 241, 0.2)',
        primary16: 'rgba(74, 102, 241, 0.16)',
        primary08: 'rgba(74, 102, 241, 0.08)',
        primary04: 'rgba(74, 102, 241, 0.04)',

        secondary: '#f50057',

        // Backgrounds (4 levels — page / card / lighter card / table header)
        bgDefault: '#f5f5f5',
        bgPaper: '#ffffff',
        bgLight: '#FAFAFA',
        bgTableHeader: '#F5F5F5',

        // Text (4 levels — primary 4.5:1+, dark headlines, medium nav, secondary captions)
        textPrimary: '#212121',
        textSecondary: '#616161',
        textDark: '#1a1a1a',
        textMedium: '#424242',

        // Lines
        divider: '#EBEBEB',
        border: '#E0E0E0',
        borderLight: '#EBEBEB',

        // Semantic (each with bg + main, warning also has border + text)
        warning: '#FF9800',
        warningBg: '#FFF4E5',
        warningBorder: '#FFE0B2',
        warningText: '#5F370E',

        error: '#F44336',
        errorBg: 'rgba(244, 67, 54, 0.08)',

        success: '#2E7D32',
        successBg: '#E8F5E9',

        info: '#0288D1',
        infoBg: '#E1F5FE',

        // Internal-note amber (used by ChatComposer + MessageBubble for "internal note" mode)
        // Sourced from prototype line 1295+ + MessageBubble usage. Lifted out of inline literals
        // so the theme stays the single source of truth.
        internalBg: '#FFF8E1',
        internalBorder: '#F57F17',
        internalText: '#5F370E',

        // Legacy aliases — components written before 2026-04-30 use these names.
        // Re-mapped to prototype values (was brand-guidelines values which never matched prototype).
        ink: '#1a1a1a',
        ink60: '#616161',
        ink40: 'rgba(0, 0, 0, 0.40)',
        ink20: 'rgba(0, 0, 0, 0.20)',
        bg: '#ffffff',
        bgMuted: '#f5f5f5',
    },
    font: {
        family: '"Roboto", "Helvetica", "Arial", sans-serif',
        monospace: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace',
    },
    radius: {
        base: 8,
        card: 12,
        cardLg: 16,
        dialog: 24,
        pill: 999,
    },
    spacing: 8,
    shadow: {
        sm: '0px 1px 3px rgba(0, 0, 0, 0.08)',
        md: '0px 2px 8px rgba(0, 0, 0, 0.08)',
        lg: '0px 4px 12px rgba(0, 0, 0, 0.10)',
        xl: '0px 8px 24px rgba(0, 0, 0, 0.12)',
        primary: '0px 4px 12px rgba(74, 102, 241, 0.3)',
        primaryHover: '0px 6px 16px rgba(74, 102, 241, 0.4)',
    },
    layout: {
        topbarHeight: 64,
        sidebarWidth: 260,
    },
    z: {
        base: 0,
        sticky: 10,
        drawer: 20,
        modal: 40,
        overlay: 100,
        toast: 1000,
    },
};
